import { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faSquare,
	faSquareCheck,
	faChevronCircleRight,
	faUpload,
} from "@fortawesome/pro-light-svg-icons";

import { API_URL_DONATE } from "../../utils/helpers";

import Alert from "../../components/Alert";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

export default function UploadPhoto({ cares, id, handleStatus }) {
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [details, setDetails] = useState({});
	const [names, setNames] = useState({
		lastYrPhoto: false,
	});
	const [msg, setMsg] = useState({});

	const formElement = useRef();

	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;

		init();
	});

	const init = async () => {
		const url = new URL(`${API_URL_DONATE}/`);
		const params = {
			f: `ccDetailsInit`,
			id,
			x: uuidv4(),
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url.href, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDetails({ ...json.details });
				if (json.details.lastYrPhoto) {
					handleUpdate("lastYrPhoto", true);
				}
				setAlert({});
			} else {
				handleStatus("", 4);
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		if (name === "lastYrPhoto") {
			const checked = !names[name];
			setNames((names) => ({ ...names, [name]: checked }));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL_DONATE}/?f=ccUploadPhoto`);

		let formData = new FormData();
		// Object.entries(names).forEach(([key, value]) => data.append(key, value));
		formData.append("lastYrPhoto", names.lastYrPhoto ? "1" : "0");
		formData.append("uploadedFileUrl", details.uploadedFileUrl);
		formData.append("id", id);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({});
				handleStatus(json.id, 2);
			} else {
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpload = async (name, value) => {
		setMsg({
			type: "working",
			text: "",
		});

		if (
			value.type !== "image/jpg" &&
			value.type !== "image/jpeg" &&
			value.type !== "image/png"
		) {
			setMsg({
				type: "error",
				text: "Please upload your file in JPG or PNG format.",
			});

			return false;
		} else if (value.size > 10000000) {
			setMsg({
				type: "error",
				text: "Please limit upload size to 10 MB.",
			});

			return false;
		} else {
			const url = new URL(`${API_URL_DONATE}/?f=ccUploadPhoto`);

			let formData = new FormData();
			// Object.entries(names).forEach(([key, value]) => data.append(key, value));
			formData.append("file", value);
			formData.append("id", id);

			try {
				const response = await fetch(url.href, {
					method: "POST",
					body: formData,
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setMsg({});
					handleStatus(json.id, 2);
				} else {
					setMsg({
						type: "error",
						text: json.text,
					});
				}
			} catch (error) {
				setMsg({
					type: "error",
					text: "An error has occurred.",
				});
			}
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<form
					method="post"
					action="/"
					onSubmit={(e) => handleSubmit(e)}
					ref={formElement}
					id="coutoureclub"
				>
					<h3>Directory Photo</h3>

					<p style={{ marginTop: "10px" }}>
						Please upload a jpeg or png that is high-resolution (selfie from
						phone is fine) that we can use in our directory.
					</p>

					<div className="buttons-container" style={{ marginTop: "0px" }}>
						<button
							type="button"
							onClick={() => handleUpdate("lastYrPhoto", names.lastYrPhoto)}
						>
							<div>
								<FontAwesomeIcon
									icon={names.lastYrPhoto ? faSquareCheck : faSquare}
								/>
								<span style={{ fontSize: "100%" }}>
									I am returning member, please use my photo from last year
								</span>
							</div>
						</button>
					</div>

					{!names.lastYrPhoto && (
						<>
							{details.uploadedFileUrl && (
								<div style={{ width: "350px" }}>
									<img src={details.uploadedFileUrl} alt="Uploaded" />
								</div>
							)}

							<label htmlFor={`file`} className="upload">
								<FontAwesomeIcon icon={faUpload} size="3x" />
								<span>Upload a photo of yourself</span>
								<input
									type="file"
									id={`file`}
									name={`file`}
									style={{ display: "none" }}
									onChange={(e) => handleUpload(`file`, e.target.files[0])}
								/>
							</label>
						</>
					)}

					{names.lastYrPhoto || details.uploadedFileUrl ? (
						<div className="msg-submit">
							{msg.type && <Msg data={msg} />}

							<div
								className={
									msg.type === "working" ? "hidden" : "submit-container"
								}
							>
								<Submit
									name="Continue to Payment"
									icon={faChevronCircleRight}
									cares={cares}
								/>
							</div>
						</div>
					) : (
						<div className="msg-submit">{msg.type && <Msg data={msg} />}</div>
					)}
				</form>
			)}
		</>
	);
}
